import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'

import {
  IMarketplaceStatPayload,
  IMarketplaceStatResponse,
  IMarketplaceStatsResponse,
  IMarketplaceStatsSumResponse,
  IMarketplaceSuitableSpotsResponse,
  IRefHostsResponse
} from '@/apps/traforama/interfaces/marketplaceStat'

import { ISpotsListResponse } from '@/apps/traforama/interfaces/spotsLists'

export const fetchItems = async (
  payload: IMarketplaceStatPayload
): Promise<IMarketplaceStatsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start, csv: !!payload.csv },
    nestedQueryFormatter('filter', payload.filter),
    nestedQueryFormatter('sorter', payload.sorter)
  )
  const response = await apiClient.get<IMarketplaceStatsResponse>(
    '/marketplace_stats',
    { params }
  )
  return response.data
}

export const fetchItem = async (
  id: string
): Promise<IMarketplaceStatResponse> => {
  const response = await apiClient.get<IMarketplaceStatResponse>(
    `/marketplace_stats/${id}`
  )
  return response.data
}

export const fetchSum = async (
  payload: IMarketplaceStatPayload
): Promise<IMarketplaceStatsSumResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start, csv: !!payload.csv },
    nestedQueryFormatter('filter', payload.filter),
    nestedQueryFormatter('sorter', payload.sorter)
  )
  const response = await apiClient.get<IMarketplaceStatsSumResponse>(
    '/marketplace_stats/calculate_sum',
    { params }
  )
  return response.data
}

export const fetchSuitableSpots = async (
  payload: IMarketplaceStatPayload
): Promise<IMarketplaceSuitableSpotsResponse> => {
  const response = await apiClient.get<IMarketplaceSuitableSpotsResponse>(
    '/marketplace_stats/suitable_spots',
    { params: payload.filter }
  )
  return response.data
}

export const searchRefHosts = async (
  query: string
): Promise<IRefHostsResponse> => {
  const response = await apiClient.get('/marketplace_stats/search_ref_hosts', {
    params: { query }
  })
  return response.data
}

export const exportToSpotsList = async (
  payload: IMarketplaceStatPayload
): Promise<ISpotsListResponse> => {
  const response = await apiClient.post<ISpotsListResponse>(
    '/marketplace_stats/export_to_spots_list',
    payload
  )
  return response.data
}
